<template>
    <div class="YCompanyPermision">
        <img :src="noPermissionSrc" alt="">
        <p>{{ title }}</p>
    </div>
</template>

<script>
    export default {
        name: "YCompanyPermision",
        props: {
            title: String
        },
        data () {
            return {
                noPermissionSrc: this.$imageSrcMap.app.nodata
            };
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>

<style lang="less" scoped>
    .YCompanyPermision {
        width: 100%;
        height: 100%;
        padding: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        p {
            margin: 10px 0;
        }
    }
</style>
<style lang="less">
    .YCompanyPermision {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/YNoPermission.vue